import styled from "styled-components";

export const LabelText = styled.div`
  font-size: 1rem;
  margin-right: 10px;
`;

export const ValueText = styled.div`
  font-size: 1rem;
  font-weight: bold;
`;

export const Subtitle = styled.div`
  font-size: 1.5rem;
  text-decoration: underline;
`;

export const ButtonAction = styled.button`
  background: #f9ae17d1;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  &:hover {
    background: #f9ae17;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(249, 174, 23, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Icon = styled.i`
  font-size: 14px;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;
